import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../img/New-logo.png';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="main-footer">
            <div className="footer-container">
                <div className="footer-content">
                    {/* Company Info Section */}
                    <div className="footer-section footer-brand">
                        <div className="footer-logo-wrapper">
                            <img src={logo} alt="Ace Keystone Consultants" className="footer-logo" />
                            <h2 className="footer-company-name">Ace Keystone Consultants</h2>
                        </div>
                        <p className="footer-description">
                            Empowering growth with precision.<br></br>
                            Where insight meets impactful execution.
                        </p>
                        <div className="footer-social-icons">
                            <a href="mailto:info@ak-tech.in" className="social-icon-link" aria-label="Email">
                                <div className="social-icon">
                                    <i className="fa fa-envelope"></i>
                                </div>
                            </a>
                            <a href="https://www.linkedin.com/company/ak-tech-group/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="LinkedIn">
                                <div className="social-icon">
                                    <i className="fab fa-linkedin-in"></i>
                                </div>
                            </a>
                        </div>
                    </div>

                    {/* Spacer for gap */}
                    <div className="footer-spacer"></div>

                    {/* Quick Links */}
                    <div className="footer-section footer-links-section">
                        <h3 className="footer-title">Quick Links</h3>
                        <div className="footer-links-grid">
                            <ul className="footer-links">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/teams">Our Team</Link></li>
                                <li><Link to="/ourtech">Our Tech</Link></li>
                            </ul>
                            <ul className="footer-links">
                                <li><Link to="/services">Our Services</Link></li>
                                <li><Link to="/careers">Careers</Link></li>
                                <li><Link to="/blogs">Blogs</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                            </ul>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-section footer-contact-section">
                        <h3 className="footer-title">Get In Touch</h3>
                        <ul className="footer-contact">
                            <li>
                                <i className="fa fa-map-marker"></i>
                                <span>113, B2 Block, Karayampalayam Road,<br />Mylampatti, Chinniyampalayam,<br />Coimbatore, Tamil Nadu - 641 062</span>
                            </li>
                            <li>
                                <i className="fa fa-phone"></i>
                                <span>+91-8925501851 (Preferred)<br />+0422-714-1405</span>
                            </li>
                            <li>
                                <i className="fa fa-envelope"></i>
                                <a href="mailto:info@ak-tech.in">info@ak-tech.in</a>
                            </li>
                            <li>
                                <i className="fa fa-id-card"></i>
                                <span>GST: 33ABCCA7274N1ZC</span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>

            {/* Bottom Bar - outside container so it spans full width */}
            <div className="footer-bottom">
                <div className="footer-bottom-content">
                    <p>&copy; {currentYear} Ace Keystone Consultants Pvt. Ltd. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
